import { RootState } from "../../../index";

export const isEmailEnabled = (state: RootState) => state?.emailSettings?.data?.isEmailEnabled;
export const companyProfileData = (state: RootState) => state?.emailSettings?.data?.profileData;
export const isDeleted = (state: RootState) => state?.emailSettings?.data?.isDeleted;
export const emailLists = (state: RootState) => state?.emailSettings?.data?.emailLists;
export const addressLists = (state: RootState) => state?.emailSettings?.data?.addressList;
export const domainLists = (state: RootState) => state?.emailSettings?.data?.domainList;
export const error = (state: RootState) => state?.emailSettings?.error;
export const domainNames = (state: RootState) => state?.emailSettings?.data?.domainName;